<div class="tnc">
    <div class="tnc__title">
        {{ termsTitle() }}
    </div>
    <div *ngIf="!isMore" class="tnc__overlay">
    </div>
    <div class="tnc__faq" [ngClass]="isMore ? 'is__more' : 'is__less'" [innerHTML]="termsContent() | safe:'html'">
    </div>
    <div class="tnc__btn">
        <!-- invalid BEM naming convention -->
        <button class="load__more__faq" (click)="toggleTerms()">
            <span *ngIf="isMore">{{ buttonTextHide() }}</span>
            <span *ngIf="!isMore">{{ buttonTextShow() }}</span>
        </button>
    </div>
</div>
